const initSlider = (section, slidesCount) => {
	const id = section.getAttribute('id');
	const slider = section.querySelector( `.mySwiper-${id}` );
	const hoverButtons = slider.querySelectorAll( '.hover-button' );
	let isLoop = false;
	let isSlider = true;
	if ( window.innerWidth > 1024 && slidesCount > 5 ) {
		isLoop = true;
	} else if ( window.innerWidth > 480 && window.innerWidth < 1024  && slidesCount > 3 ) {
		isLoop = true;
	}
	if ( window.innerWidth > 1024 && slidesCount < 4 )
	{
		isSlider = false;
	} else if ( window.innerWidth > 480 && window.innerWidth < 1024  && slidesCount < 3 ) {
		isSlider = false;
	}

	if ( isSlider ) {

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 20,
			loop: isLoop,
			freeMode: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			  },
			breakpoints: {
	
				1000: {
					slidesPerView: 3,
				},
				480: {
					slidesPerView: 2,
				},
			},
		});
		
		swiper.setProgress(0);

		if ( slider.classList.contains( 'hover' ) ) {
			const slidesGrabbing = (direction) => {
				const interval = setInterval( () => {
					swiper.setProgress(direction === 1 ? swiper.progress += 0.01 : swiper.progress -= 0.01, 300);
				}, 100);
	
				hoverButtons[direction].onmouseleave = () => {
					clearInterval(interval);
				}
			}
			
			hoverButtons[0].onmouseover = function(event) {
				slidesGrabbing(0);
			};
	
			hoverButtons[1].onmouseover = function(event) {
				slidesGrabbing(1);
			};
		} 
	}
}

const initCards = () => {
	const sections = document.querySelectorAll( 'section.cards' );
	
	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
			const id = section.getAttribute('id');
			const slider = section.querySelector( `.mySwiper-${id}` );
			const slidesContainer = slider.querySelector( 'ul' );
			const hoverButtons = slider.querySelectorAll( '.hover-button' );
			const slides = slider.querySelectorAll( 'ul li' );
			const categoriesList = section.querySelector( 'ul.type-buttons' );
			let categories = [];
			let indexes = [];

			const swiper = new Swiper(slider, {
				slidesPerView: 1.2,
				spaceBetween: 20,
				loop: true,
				freeMode: false,
				navigation: {
					nextEl: `.slider-next-${id}`,
					prevEl: `.slider-prev-${id}`,
				  },
				breakpoints: {

					1024: {
						slidesPerView: 3,
						freeMode: true,
					},
					768: {
						slidesPerView: 2,
					},
				},
			});

			const updateSlider = (slidesCount) => {
				swiper.destroy();
				initSlider(section, slidesCount);
				
			}

			if ( slider.classList.contains( 'hover' ) ) {
				const slidesGrabbing = (direction) => {
					const interval = setInterval( () => {
						swiper.setProgress(direction === 1 ? swiper.progress += 0.01 : swiper.progress -= 0.01, 300);
					}, 100);
	
					hoverButtons[direction].onmouseleave = () => {
						clearInterval(interval);
					}
				}
				
				hoverButtons[0].onmouseover = function(event) {
					slidesGrabbing(0);
				};
	
				hoverButtons[1].onmouseover = function(event) {
					slidesGrabbing(1);
				};
			} 

			slides.forEach( (item) => { 
				if (item.getAttribute( 'data-type' )) {
					categories.push(item.getAttribute( 'data-type' )) 
				}
			})
			categories = [...new Set(categories)];
			if ( categories.length > 1 ) {
				categoriesList.innerHTML = categories.map( (item, index) => {
					return	`<li ${index == 0 ? 'class="active"' : ''} data-index="${index}">${item}</li>`
				}).join( '' );

				const changeSlidesListAndUpdateSlider = (index) => {
					slidesContainer.innerHTML = '';
					[...slides].forEach( (item) => {
						if ( item.getAttribute( 'data-type' ) == categories[index]) {
							slidesContainer.insertAdjacentElement( 'beforeend', item );
						}
					})
					updateSlider(slidesContainer.childNodes.length);
				}

				for ( let categoryButton of categoriesList.childNodes ) {
					categoryButton.addEventListener( 'click', () => {
						categoriesList.childNodes.forEach( item => {
							item.classList.remove( 'active' );
						})
						categoryButton.classList.add( 'active' );
						changeSlidesListAndUpdateSlider(categoryButton.getAttribute( 'data-index' ))
					})
				}
				changeSlidesListAndUpdateSlider(0);
			}
		} )
	}
}

export {
	initCards,
};